/**
 * MATCH Journey Configuration
 *
 * Defines the match booking flow: addons → association-info → summary → complete
 * Uses the timeslot's availability type defaults (BOOKING or REQUEST) with journey-specific overrides for UX.
 */

import { inject } from '@angular/core';

import { CheckoutJourney } from '../models/checkout-journey.types';
import { BookingTypeName } from '@shared/models/enums';
import { CheckoutStore } from '../checkout.store';

export const MATCH_JOURNEY: CheckoutJourney = {
  type: BookingTypeName.MATCH,
  searchRoute: 'associations/search/match', // Base search route for "return to search" functionality
  page: [
    {
      pageRoute: 'addons',
      label: 'Tilvalg',
      ariaLabel: 'Tilvalg',
      autoAddLockerRooms: 2, // 🎯 MATCH-specific: Auto-add 2 locker rooms (home/away teams)
    },
    {
      pageRoute: 'association-info',
      label: 'Foreningsinfo',
      ariaLabel: 'Foreningsinfo',
    },
    {
      pageRoute: 'summary',
      label: 'Oversigt',
      ariaLabel: 'Oversigt',

      canActivate: () => {
        const store = inject(CheckoutStore);
        return !!store.bookingId();
      },
    },
    {
      pageRoute: 'complete',
      label: 'Gennemført',
      ariaLabel: 'Gennemført',
      // No title override: a match slot is booked or requested by its availability type (#748)
    },
  ],
};
